import { LUDUM_USER_STATUSES, LUDUM_USER_ROLES } from '@/constants';
const { LEFT } = LUDUM_USER_STATUSES;
const { ATHLETE, HEAD_COACH, COACH } = LUDUM_USER_ROLES;

export const clubHelper = {
    namespaced: true,

    state: {
        me: null,
        users: [],
        squads: [],
        eventTags: [],
        focuses: [],
        intensities: [],
        sessionTypes: [],
        unitsOfMeasurement: [],
        numberOfUnreadNotifications: 0,
        googleMapsLoaded: false
    },

    getters: {
        me(state) {
            return state.me;
        },
        clubUsers(state) {
            return _.sortBy(state.users.filter(user => user.current_club_user.data.status.id !== LEFT), 'full_name');
        },

        inactiveClubUsers(state) {
            return _.sortBy(state.users.filter(user => user.current_club_user.data.status.id === LEFT), 'full_name');
        },

        clubAthletes(state, getters) {
            return _.filter(getters.clubUsers, user => _.some(user.current_club_roles.data, { id: ATHLETE }));
        },

        clubCoaches(state, getters) {
            return _.filter(
                getters.clubUsers,
                user =>
                    _.some(user.current_club_roles.data, { id: COACH }) ||
                    _.some(user.current_club_roles.data, { id: HEAD_COACH })
            );
        },

        clubSquads(state) {
            return _.sortBy(state.squads, squad => squad.name.toLowerCase());
        },

        clubEventTags(state) {
            return _.sortBy(state.eventTags, 'name');
        },

        clubFocuses(state) {
            return _.sortBy(state.focuses, 'name');
        },

        clubIntensities(state) {
            return _.sortBy(state.intensities, 'order');
        },

        clubSessionTypes(state) {
            return _.sortBy(state.sessionTypes, 'id');
        },

        unitsOfMeasurement(state) {
            return _.sortBy(state.unitsOfMeasurement, 'id');
        },

        numberOfUnreadNotifications(state) {
            return state.numberOfUnreadNotifications;
        },

        googleMapsLoaded(state) {
            return state.googleMapsLoaded;
        }
    },

    mutations: {
        emptySquads(state) {
            state.squads = [];
        },

        fillMe(state, data) {
            state.me = data;
        },

        fillUsers(state, data) {
            state.users = data;
        },

        fillSquads(state, data) {
            state.squads = data;
        },

        fillEventTags(state, data) {
            state.eventTags = data;
        },

        fillFocuses(state, data) {
            state.focuses = data;
        },

        emptyIntensities(state) {
            state.intensities = [];
        },

        fillIntensities(state, data) {
            state.intensities = data;
        },

        fillSessionTypes(state, data) {
            state.sessionTypes = [...data];
        },

        fillUnitsOfMeasurement(state, data) {
            state.unitsOfMeasurement = [...data];
        },
        fillNumberOfUnreadNotifications(state, data) {
            state.numberOfUnreadNotifications = data;
        },
        updateGoogleMaps(state, data) {
            state.googleMapsLoaded = data;
        }
    },

    actions: {
        getMe(context) {
            return context
                .dispatch(
                    'get',
                    {
                        url:
                            api +
                            'me?fields=id|first_name|last_name|full_name|email|picture|is_admin|firebase_password|created_at'
                    },
                    { root: true }
                )
                .then(response => {
                    context.commit('fillMe', response.data);
                    context.dispatch('subscribeToUpdates', response.data, { root: true });
                    return response;
                });
        },

        getClubSquads(context, payload) {
            return context
                .dispatch(
                    'get',
                    {
                        url: api + 'squads',
                        params: {
                            club_id: payload.club_id,
                            include: 'squad_users',
                            limit: 1000 // limit agreed with Ivan
                        }
                    },
                    { root: true }
                )
                .then(response => {
                    context.commit('emptySquads');
                    context.commit('fillSquads', response.data.data);
                    return response;
                });
        },

        getClubUsers(context, payload) {
            const { page, clubId, status } = payload;
            return context
                .dispatch(
                    'get',
                    {
                        url:
                            window.api +
                            'club-users?fields=id|full_name|first_name|last_name|status|picture|date_of_birth|gender|user_groups',
                        params: {
                            club_id: clubId,
                            status,
                            page,
                            limit: 1000,
                            include:
                                'current_club_user:fields(cox|stroke|scull|sweep|status),' +
                                'last_user_stat:fields(healthy|ill|injured),crew_user_groups,user_squads.squad:fields(id|name),current_club_roles'
                        }
                    },
                    { root: true }
                )
                .then(results => {
                    return results;
                });
        },

        getIntensities(context) {
            context
                .dispatch(
                    'get',
                    {
                        url: api + 'intensities'
                    },
                    {
                        root: true
                    }
                )
                .then(response => {
                    context.commit('emptyIntensities');
                    context.commit('fillIntensities', response.data);
                    context.commit('intensities', response.data, { root: true });
                    context.dispatch('newSessionIntensities', response.data, { root: true });
                    return response;
                });
        },

        getNotifications(context, params) {
            return context.dispatch(
                'get',
                {
                    url: api + 'notifications',
                    params
                },
                { root: true }
            );
        },

        getNumberOfUnreadNotifications(context) {
            if (!context.rootGetters.selectedClub) {
                return;
            }
            return context
                .dispatch(
                    'get',
                    {
                        url: api + 'notifications/number-of-unread',
                        params: {
                            club_id: context.rootGetters.selectedClub.club_id
                        }
                    },
                    { root: true }
                )
                .then(response => {
                    context.commit('fillNumberOfUnreadNotifications', response.data.number_of_unread);
                    return response;
                });
        }
    }
};

export default clubHelper;
